module.exports = __webpack_public_path__ + "static/media/mr2_assets.a822817c.png";